import axios from 'axios';
import profile from 'config/profile';

export const setAxiosHeaders = function(headers) {
  for (const header in headers) {
    if (headers.hasOwnProperty(header))
    axios.defaults.headers.common[header] = headers[header];
  }
  console.log('Set default headers in axios: ', axios.defaults.headers.common);
}

export const api_v1 = axios.create({
  baseURL: `${profile.apiUrl}/api/v1/`,
  withCredentials: true,
  responseType: 'json'
});

export const api_v2 = axios.create({
  baseURL: `${profile.apiUrl}/api/v2/`,
  withCredentials: true,
  responseType: 'json'
});
